import { SearchPageName } from '@/types/search/searchQuery';
import { getIsCollectionsPage, getIsSEOSearchPage, getIsSEOSearchPageWithLocation } from '@/utils/urls';

type GetSearchPageNameParams = {
    archivedSearch: boolean;
    pathname: string;
};

export const getSearchPageName = ({ archivedSearch, pathname }: GetSearchPageNameParams): SearchPageName => {
    if (getIsSEOSearchPage(pathname) || getIsSEOSearchPageWithLocation(pathname)) {
        return SearchPageName.SEO_SEARCH;
    }
    if (getIsCollectionsPage(pathname)) {
        return SearchPageName.COLLECTIONS;
    }
    return archivedSearch ? SearchPageName.SOLD_SEARCH : SearchPageName.SEARCH;
};
